import React from 'react';

interface Crumb {
  label: string;
}

interface Props {
  trail: Crumb[];
}

export const Breadcrumbs = ({ trail }: Props): JSX.Element => (
  <div className="docs-breadcrumbs">
    {trail.map((crumb, index) => (
      <React.Fragment key={`${crumb.label}-${index}`}>
        {index > 0 && <span aria-hidden="true">/</span>}
        <span>{crumb.label}</span>
      </React.Fragment>
    ))}
  </div>
);
